import { useEffect, useState } from "react";

import { ApiFehler, blobLaden } from "../api/client";

interface BlobZustand {
  url: string | null;
  blob: Blob | null;
  laedt: boolean;
  fehler: ApiFehler | null;
}

/** Lädt eine geschützte Datei (mit Token) und stellt sie als Object-URL bereit. */
export function useBlobUrl(pfad: string | null): BlobZustand {
  const [zustand, setZustand] = useState<BlobZustand>({ url: null, blob: null, laedt: Boolean(pfad), fehler: null });

  useEffect(() => {
    if (!pfad) {
      setZustand({ url: null, blob: null, laedt: false, fehler: null });
      return;
    }
    const abbruch = new AbortController();
    let url: string | null = null;
    setZustand({ url: null, blob: null, laedt: true, fehler: null });
    blobLaden(pfad, abbruch.signal)
      .then((blob) => {
        url = URL.createObjectURL(blob);
        setZustand({ url, blob, laedt: false, fehler: null });
      })
      .catch((e: unknown) => {
        if (e instanceof DOMException && e.name === "AbortError") return;
        const fehler = e instanceof ApiFehler ? e : new ApiFehler(0, "unbekannt", "Datei konnte nicht geladen werden");
        setZustand({ url: null, blob: null, laedt: false, fehler });
      });
    return () => {
      abbruch.abort();
      if (url) URL.revokeObjectURL(url);
    };
  }, [pfad]);

  return zustand;
}
